import { render, staticRenderFns } from "./FullReductionSkuInfo.vue?vue&type=template&id=28c0a1d9&scoped=true&"
import script from "./FullReductionSkuInfo.vue?vue&type=script&lang=js&"
export * from "./FullReductionSkuInfo.vue?vue&type=script&lang=js&"
import style0 from "./FullReductionSkuInfo.vue?vue&type=style&index=0&id=28c0a1d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0a1d9",
  null
  
)

export default component.exports